import * as React from 'react';
import { IChangeEventHandler } from '../../_types/nav';
import Moment from 'react-moment'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ICredential } from '../../_types/user';
import { Button } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { DeleteCredential, IssueForgotPasswordEmail, LogOutAllDevices } from '../../_service/user';

interface Props {
    onChange: IChangeEventHandler<ICredential>;
    credential: ICredential;
};


const UserCredential: React.FC<Props> = (prop: Props) => {

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
    }),
  );

  const classes = useStyles();

  const deleteCredential = () => {

    DeleteCredential(prop.credential).then(r => {
      prop.onChange(prop.credential);
    })
  }

  const _canDelete = () => {
    return prop.credential.expired_at !== null;
  }

  const issueForgotPasswordEmail = () => {

    IssueForgotPasswordEmail(prop.credential.user_id).then(r => {
      if (r) {
        prop.onChange(r);
      }
    })

  }



  return (
      <TableRow>
        <TableCell align="left">{prop.credential.provider.replace("authprovider.", "")}</TableCell>
        <TableCell align="left">{prop.credential.token}</TableCell>
        <TableCell align="left">
          {prop.credential.created_at && 
            (
              <Moment date={prop.credential.created_at} format="YYYY/MM/DD hh:mm:ss"/>
            )
          }
        </TableCell>
        <TableCell align="left">
          {prop.credential.attempts && (
            <span>{prop.credential.attempts}</span>
          )}
        </TableCell>
        <TableCell align="left">
          {prop.credential.expired_at && 
            (
              <Moment date={prop.credential.expired_at} format="YYYY/MM/DD hh:mm:ss"/>
            )
          }
        </TableCell>
        <TableCell align="left">
          {prop.credential.locked ? "Locked": ""}
        </TableCell>
        <TableCell align="left">
          {_canDelete() && (
            <Button variant="contained" size="small" color="secondary" onClick={(e)=>{ deleteCredential() }}>Delete</Button>
          )}
          {prop.credential.expired_at === null && prop.credential.provider==="authprovider.userdefined" && (
            <Button variant="contained" size="small" color="secondary" onClick={(e)=>{ issueForgotPasswordEmail() }}>Forgot Password</Button>
          )}
          
        </TableCell>
      </TableRow>
      )
}

export default UserCredential;

/*
    <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={3}>
        <Grid item>
          {prop.credential.provider.replace("authprovider.", "")}
        </Grid>
        <Grid item>
          {prop.credential.token}
        </Grid>
        <Grid item>
          {prop.credential.locked ? "Locked": ""}
        </Grid>
        {
          (prop.credential.attempts > 0) && (
            <Grid item>
              {prop.credential.attempts} Attempts
            </Grid>
          )
        }
        { prop.credential.issued_at && (
        <Grid item>
          Issued on <Moment date={prop.credential.issued_at} format="YYYY/MM/DD hh:mm:ss"/>
        </Grid>
        )}
        { prop.credential.expired_at && (
        <Grid item>
          Expired on <Moment date={prop.credential.expired_at} format="YYYY/MM/DD hh:mm:ss"/>
        </Grid>        
        )}
        
    </Grid>
*/